// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import type {
    CourseContainerClientData,
    Problem,
    Stack,
    ThemeAttribute,
    ThemeDetails,
} from '@yandex-int/k-common/typings';
// @ts-ignore
import { History } from 'history';
import { SimpleCallback } from 'platform-components';

import * as constants from './constants';

export const getStackProblemsRequest = (stacks: Array<Stack>, themeId: number) =>
    <const>{ type: constants.GET_STACK_PROBLEMS_REQUEST, stacks, themeId };

export const getStackProblemsSuccess = (problems: Array<Stack>, themeId: number) =>
    <const>{ type: constants.GET_STACK_PROBLEMS_SUCCESS, problems, themeId };

export const getStackProblemsError = (error: any) => <const>{ type: constants.GET_STACK_PROBLEMS_ERROR, error };

export const getAllAttributesRequest = (themeId: number) =>
    <const>{ type: constants.GET_ALL_ATTRIBUTES_REQUEST, themeId };

export const getAvailableAttributesRequest = (themeId: number) =>
    <const>{ type: constants.GET_AVAILABLE_ATTRIBUTES_REQUEST, themeId };

export const getAllAttributesSuccess = (themeId: number, attributes: Array<ThemeAttribute>) =>
    <const>{
        type: constants.GET_ALL_ATTRIBUTES_SUCCESS,
        themeId,
        attributes,
    };

export const getAvailableAttributesSuccess = (themeId: number, attributes: Array<ThemeAttribute>) =>
    <const>{
        type: constants.GET_AVAILABLE_ATTRIBUTES_SUCCESS,
        themeId,
        attributes,
    };

export const applyFilterFromUrl = (history: History) => <const>{ type: constants.APPLY_FILTER_FROM_URL, history };

interface changeFilterValueOptions {
    history: History;
    themeId: number;
}

export const changeFilterValue = (filterSlug: string, filterValue: any, options: changeFilterValueOptions) =>
    <const>{
        type: constants.CHANGE_FILTER_VALUE,
        filterSlug,
        filterValue,
        history: options.history,
        themeId: options.themeId,
    };

export const setFilterValue = (filterSlug: string, filterValue: any) =>
    <const>{ type: constants.SET_FILTER_VALUE, filterSlug, filterValue };

export const setFilters = (filters: Record<string, any>) => <const>{ type: constants.SET_FILTERS, filters };

export const clearFilters = (history: History, themeId: number) =>
    <const>{ type: constants.CLEAR_FILTERS, history, themeId };

export const selectStack = (stackId: number | null) => <const>{ type: constants.SELECT_STACK, stackId };

export const selectDeepLinkStack = (stackId: number) => <const>{ type: constants.SELECT_DEEP_LINK_STACK, stackId };

export const setDeepLinkStack = (stack: Stack) => <const>{ type: constants.SET_DEEP_LINK_STACK, stack };

export const addProblemToLesson = (problem: Problem, stackId: number) =>
    <const>{ type: constants.ADD_PROBLEM_TO_LESSON, problem, stackId };

export const getThemeDetailsRequest = (themeId: number) =>
    <const>{ type: constants.GET_THEME_DETAILS_REQUEST, themeId };

export const getThemeDetailsSuccess = (themeId: number, themeDetails: ThemeDetails) =>
    <const>{ type: constants.GET_THEME_DETAILS_SUCCESS, themeId, themeDetails };

export const getThemeDetailsError = (err: any, themeId: number) =>
    <const>{ type: constants.GET_THEME_DETAILS_ERROR, themeId, err };

export const loadStacksRequest = (themeId: number, page: number) =>
    <const>{ type: constants.LOAD_STACKS_REQUEST, themeId, page };

export const loadStacksSuccess = (stacks: Array<Stack>, themeId: number, page: number, canLoadMore: boolean) =>
    <const>{ type: constants.LOAD_STACKS_SUCCESS, stacks, themeId, page, canLoadMore };

export const loadStacksError = (error: any) => <const>{ type: constants.LOAD_STACKS_ERROR, error };

export const clearStacks = () => <const>{ type: constants.CLEAR_STACKS };

export const lessonModalClose = () => <const>{ type: constants.LESSON_MODAL_CLOSE };

export const saveLesson = () => <const>{ type: constants.SAVE_LESSON };

export const addNewSubject = (payload: { teamId: number; subject: SUBJECTS_SLUGS; onSuccess: SimpleCallback }) =>
    <const>{ type: constants.ADD_NEW_SUBJECT, payload };

export const getCoursesPreviewRequest = () => <const>{ type: constants.GET_COURSES_PREVIEW_REQUEST };

export const getCoursesPreviewSuccess = (payload: CourseContainerClientData[]) =>
    <const>{ type: constants.GET_COURSES_PREVIEW_SUCCESS, payload };

export const getCoursesPreviewError = () => <const>{ type: constants.GET_COURSES_PREVIEW_ERROR };
